import bugsnag from '@bugsnag/js';
import bugsnagReact from '@bugsnag/plugin-react';
import React from 'react';

const bugsnagClient = bugsnag({
  apiKey: `${process.env.REACT_APP_BUG_SNAG_API_KEY}`,
  appVersion: process.env.REACT_APP_VERSION_APP,
});

bugsnagClient.use(bugsnagReact, React);

const { notify: bugsnagNotify } = bugsnagClient;
const ErrorBoundaryBugsnag = bugsnagClient.getPlugin('react');

export { bugsnagNotify, ErrorBoundaryBugsnag };
